<template>
    <div class="form">
        <h4 class="step-title">
            Are you interested in {{(this.lead.currentResidenceType == "Own" ? "Home Owner's" : "Renter's")}} Insurance quotes too?
        </h4>
        <div class="step-content d-flex flex-column flex-md-row">
            <yes-no-button-list v-bind:onclick="complete"></yes-no-button-list>
        </div>
    </div>
</template>

<script>
    import YesNoButtonList from "./shared/YesNoButtonList.vue"

    export default {
        name: "IsInterestedInHomeOrRentersInsuranceQuotes",
        components: {
            YesNoButtonList
        },
        props: {
            lead: Object
        },
        methods: {
          complete: function(isInterestedInHomeOrRentersInsuranceQuotes) {
              this.lead.isInterestedInHomeOrRentersInsuranceQuotes = isInterestedInHomeOrRentersInsuranceQuotes;
              this.$emit("complete", this.$options.name, isInterestedInHomeOrRentersInsuranceQuotes);
          }
        }
    }
</script>
